import { Select, MenuItem, SelectChangeEvent } from "@mui/material";
import { useEffect, useState } from "react";
import { ResponseGetAllStatusResponse } from "../services/OpenAPI";

type Props = {
  statusId?: number;
  options: ResponseGetAllStatusResponse[];
  initialValue?: number;
  value?: number;
  onChange: (selectedId: number) => void;
  width?: number | string;
  isDisabled?: boolean;
};

const StatusSelect = ({
  statusId,
  options,
  initialValue,
  value,
  onChange,
  width = 150,
  isDisabled = false,
}: Props) => {
  const [selectedId, setSelectedId] = useState<number>(
    initialValue ?? options[0]?.id ?? 0,
  );

  const handleChange = (e: SelectChangeEvent<number>) => {
    const newValue = Number(e.target.value);
    setSelectedId(newValue);
    onChange(newValue);
  };

  useEffect(() => {
    if (initialValue !== undefined) {
      setSelectedId(initialValue);
    }
  }, [initialValue]);

  return (
    <Select
      value={value !== undefined ? value : selectedId}
      onChange={handleChange}
      size="small"
      sx={{ minWidth: width }}
      disabled={isDisabled}
    >
      {options
        .filter((status) => {
          if (statusId && statusId <= 3) {
            return [1, 2, 3, 6].includes(status.id ?? 0);
            // return [1, 2, 3, 4, 5, 6].includes(status.id ?? 0);
          } else if (statusId && statusId === 4) {
            return [4, 6].includes(status.id ?? 0);
          } else if (statusId === 5) {
            return [5].includes(status.id ?? 0);
          }
          return true;
        })
        .map((status) => (
          <MenuItem key={status.id} value={status.id}>
            {status.name}
          </MenuItem>
        ))}
    </Select>
  );
};

export default StatusSelect;
